import React, { useState } from "react";
import {
    TvButton,
    TvModalRoot,
    TvModalHead,
    TvModalMain,
    TvModalFoot,
    TvInput,
    TvLabel,
    TvSpinner,
    TvAlert,
    TvDiv,
    TvImg,
    TvP,
} from "@trustvid/design-system";
import { enableMFA, verifyMFA } from "../../../services/mfa";
import { toast } from "react-toastify";
import {useNavigate} from "react-router-dom";
import { persistUserData } from "../../../utils/auth-helpers";

const MFASettings = ({ isOpen, toggle, user }) => {
    const [qrCode, setQrCode] = useState("");
    const [, setMfaSecret] = useState("");
    const [mfaCode, setMfaCode] = useState("");
    const [isMfaEnabled, setIsMfaEnabled] = useState(user?.is_mfa_enabled || false);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleEnableMFA = async () => {
        setLoading(true);
        try {
            const response = await enableMFA();
            setQrCode(response.qrCode);
            setMfaSecret(response.secret);
            toast.info("Scan the QR code with your authenticator app.");
        } catch (error) {
            toast.error("Failed to enable MFA. Try again.");
        }
        setLoading(false);
    };

    const handleVerifyMFA = async () => {
        if (!mfaCode) {
            toast.error("Please enter the MFA code.");
            return;
        }
        setLoading(true);
        try {
            const response = await verifyMFA(mfaCode);
            
            if (response.success) {
                toast.success("MFA enabled successfully!");
                
                setIsMfaEnabled(true);

                localStorage.setItem("token", response?.token);
                localStorage.setItem("userType", "user");
                persistUserData(response?.user);
                navigate("/dashboard");
                toast.success("Login successful!");
            } else {
                toast.error("Invalid MFA code. Try again.");
            }
        } catch (error) {
            toast.error("MFA verification failed.");
        }
        setLoading(false);
    };

    return (
        <TvModalRoot isOpen={isOpen} toggle={toggle} centered>
            <TvModalHead toggle={toggle}>Enable Multi-Factor Authentication (MFA)</TvModalHead>
            <TvModalMain>
                {isMfaEnabled ? (
                    <TvAlert color="success">MFA is already enabled on your account.</TvAlert>
                ) : (
                    <>
                        <TvButton color="primary" onClick={handleEnableMFA} disabled={loading} block>
                            {loading ? <TvSpinner size="sm" color="light" /> : "Generate QR Code"}
                        </TvButton>

                        {qrCode && (
                            <TvDiv className="text-center mt-3">
                                {/*<QRCodeCanvas value={qrCode} size={200}/>*/}
                                <TvImg src={qrCode} alt="MFA QR Code" width={200} height={200}/>
                                <TvP>Scan this QR code in your authenticator app.</TvP>
                                <TvLabel>Enter MFA Code:</TvLabel>
                                <TvInput
                                    type="text"
                                    value={mfaCode}
                                    onChange={(e) => setMfaCode(e.target.value)}
                                    placeholder="Enter code"
                                />
                            </TvDiv>
                        )}
                    </>
                )}
            </TvModalMain>
            <TvModalFoot>
                <TvButton color="secondary" onClick={toggle}>Cancel</TvButton>
                <TvButton color="success" onClick={handleVerifyMFA} disabled={loading || !mfaCode}>
                    {loading ? <TvSpinner size="sm" color="light" /> : "Verify & Enable"}
                </TvButton>
            </TvModalFoot>
        </TvModalRoot>
    );
};

export default MFASettings;
